export const TABLE_CONFIG = {
  scheduledChats: {
    numRows: 10,
  },
};
